import React from "react";
import ReactWizard from "../Wizard";
import OrgInfo from "./components/OrgFormComponents/OrganizationInformation";
import UserInfo from "./components/OrgFormComponents/UserInformation";
import AddressInfo from "./components/OrgFormComponents/AddressInformation";

const STEPS = [
  {
    stepName: "Organization",
    component: OrgInfo,
  },
  {
    stepName: "User",
    component: UserInfo,
  },
  {
    stepName: "Address",
    component: AddressInfo,
  },
];

const OrgForm = (props) => {
  return (
    <ReactWizard
      steps={STEPS}
      title={"Add Organization"}
      validate
      finishButtonClick={(data) => props.onFormSubmit(data)}
    />
  );
};

export default OrgForm;
